import React from 'react';
import { Link } from 'react-router-dom';

export default function Privacy() {
  return (
    <div style={s.page}>
      <div style={s.container}>

        <div style={s.header}>
          <Link to="/" style={s.back}>← Back to App</Link>
          <h1 style={s.title}>🔒 Privacy Policy</h1>
          <p style={s.sub}>தனியுரிமைக் கொள்கை | Effective: April 2026</p>
        </div>

        <div style={s.highlight}>
          Your privacy is important to us. We are committed to protecting your personal information.
          JSMSTOCK does NOT sell your data to anyone.
        </div>

        <h2 style={s.h2}>1. Data We Collect</h2>
        <h3 style={s.h3}>Information You Provide:</h3>
        <ul style={s.ul}>
          <li>Name and shop name (account creation)</li>
          <li>Mobile number (OTP login / contact)</li>
          <li>Email address (optional, for password reset)</li>
          <li>Business data: Items, bills, customers, suppliers (entered by you)</li>
        </ul>
        <h3 style={s.h3}>Automatically Collected:</h3>
        <ul style={s.ul}>
          <li>Login timestamps and activity logs</li>
          <li>Device and browser information</li>
          <li>IP address (security monitoring only)</li>
        </ul>
        <div style={s.greenBox}>
          ✅ We do NOT collect: Bank account details, Aadhaar, PAN, or financial credentials.
        </div>

        <h2 style={s.h2}>2. How We Use Your Data</h2>
        <ul style={s.ul}>
          <li>To provide and improve the JSMSTOCK service</li>
          <li>To send OTP for login and verification</li>
          <li>To send trial and payment reminders</li>
          <li>To provide customer support</li>
          <li>To detect and prevent fraud or abuse</li>
          <li>To comply with legal obligations</li>
        </ul>
        <div style={s.greenBox}>
          ✅ We do NOT use your data for advertising, profiling, or marketing to third parties.
        </div>

        <h2 style={s.h2}>3. Data Sharing</h2>
        <div style={s.warning}>
          <strong>🔴 WE DO NOT SELL YOUR DATA.</strong><br/>
          <strong>🔴 WE DO NOT SHARE YOUR DATA WITH THIRD PARTIES.</strong>
        </div>
        <p style={s.p}>Limited sharing only for service delivery:</p>
        <ul style={s.ul}>
          <li><strong>AWS (Amazon Web Services)</strong> — Server hosting (India region)</li>
          <li><strong>MSG91</strong> — SMS OTP delivery (phone number only)</li>
          <li><strong>Gmail SMTP</strong> — Email delivery (email address only)</li>
        </ul>
        <p style={s.p}>All service providers are bound by strict data protection agreements.</p>

        <h2 style={s.h2}>4. Data Security</h2>
        <ul style={s.ul}>
          <li>Data stored on <strong>AWS Mumbai (India)</strong> servers</li>
          <li>HTTPS encryption for all data transmission</li>
          <li>Passwords hashed with bcrypt (never stored in plain text)</li>
          <li>JWT tokens with expiry for session management</li>
          <li>Regular security updates and monitoring</li>
          <li>Access limited to authorized personnel only</li>
        </ul>

        <h2 style={s.h2}>5. Data Retention</h2>
        <ul style={s.ul}>
          <li>Active accounts: Data kept as long as account is active</li>
          <li>Cancelled accounts: Data retained 90 days, then deleted</li>
          <li>Logs: Retained 30 days for security purposes</li>
          <li>You can request immediate deletion by contacting us</li>
        </ul>

        <h2 style={s.h2}>6. Your Rights</h2>
        <p style={s.p}>Under India's data protection laws, you have the right to:</p>
        <ul style={s.ul}>
          <li><strong>Access</strong> — Request a copy of your personal data</li>
          <li><strong>Correction</strong> — Request correction of inaccurate data</li>
          <li><strong>Deletion</strong> — Request deletion of your data</li>
          <li><strong>Portability</strong> — Request your data in readable format</li>
          <li><strong>Objection</strong> — Object to processing of your data</li>
        </ul>
        <p style={s.p}>To exercise these rights: Contact us at support@jsmstock.com</p>

        <h2 style={s.h2}>7. OTP & Mobile Data</h2>
        <ul style={s.ul}>
          <li>Your mobile number is used ONLY for OTP verification</li>
          <li>We do not make unsolicited calls to your number</li>
          <li>SMS sent only for: OTP, Trial reminders, Payment reminders</li>
          <li>You can opt out of non-essential SMS by contacting us</li>
        </ul>

        <h2 style={s.h2}>8. Cookies & Local Storage</h2>
        <ul style={s.ul}>
          <li>JSMSTOCK uses browser <strong>localStorage</strong> (not cookies)</li>
          <li>localStorage stores: Login token only</li>
          <li>No third-party tracking or advertising cookies</li>
        </ul>

        <h2 style={s.h2}>9. Contact for Privacy</h2>
        <div style={s.contactBox}>
          <p style={{margin:'4px 0'}}>📧 Email: support@jsmstock.com</p>
          <p style={{margin:'4px 0'}}>📱 WhatsApp: +91-9159933276 (6PM–9PM, Mon–Sat)</p>
          <p style={{margin:'4px 0'}}>📍 Address: Madurai, Tamil Nadu, India</p>
          <p style={{margin:'4px 0', color:'#888', fontSize:'13px'}}>Response time: Within 48 hours</p>
        </div>

        <div style={s.legalLinks}>
          <Link to="/terms"   style={s.llink}>Terms of Service</Link>
          <span style={s.sep}>|</span>
          <Link to="/privacy" style={s.llink}>Privacy Policy</Link>
          <span style={s.sep}>|</span>
          <Link to="/refund"  style={s.llink}>Refund Policy</Link>
        </div>
        <p style={s.copy}>© 2026 JSMSTOCK | Madurai, Tamil Nadu | support@jsmstock.com</p>
      </div>
    </div>
  );
}

const s = {
  page:{background:'#f5f6fa',minHeight:'100vh',padding:'20px 16px'},
  container:{maxWidth:'800px',margin:'0 auto',background:'white',borderRadius:'12px',padding:'32px',boxShadow:'0 2px 12px rgba(0,0,0,0.08)'},
  header:{marginBottom:'24px',paddingBottom:'20px',borderBottom:'3px solid #3498DB'},
  back:{color:'#3498DB',textDecoration:'none',fontSize:'14px',fontWeight:'600'},
  title:{color:'#2C3E50',margin:'12px 0 4px',fontSize:'26px',fontWeight:'900'},
  sub:{color:'#888',margin:0,fontSize:'14px'},
  highlight:{background:'#E8F8F0',border:'1px solid #27AE60',borderLeft:'5px solid #27AE60',padding:'14px 16px',borderRadius:'6px',marginBottom:'24px',fontSize:'14px',color:'#1a7a40',fontWeight:'600'},
  h2:{color:'#2C3E50',fontSize:'18px',fontWeight:'800',marginTop:'28px',marginBottom:'8px',paddingBottom:'6px',borderBottom:'2px solid #EEE'},
  h3:{color:'#3498DB',fontSize:'15px',fontWeight:'700',marginTop:'16px',marginBottom:'6px'},
  p:{color:'#444',fontSize:'14px',lineHeight:'1.7',marginBottom:'8px'},
  ul:{color:'#444',fontSize:'14px',lineHeight:'2',marginBottom:'8px',paddingLeft:'20px'},
  greenBox:{background:'#E8F8F0',border:'1px solid #27AE60',borderLeft:'5px solid #27AE60',padding:'12px 16px',borderRadius:'6px',fontSize:'14px',color:'#1a7a40',marginBottom:'8px'},
  warning:{background:'#FFF5F5',border:'1px solid #E74C3C',borderLeft:'5px solid #E74C3C',padding:'14px 16px',borderRadius:'6px',fontSize:'14px',color:'#C0392B',marginBottom:'12px'},
  contactBox:{background:'#EBF5FB',border:'1px solid #3498DB',borderLeft:'5px solid #3498DB',padding:'14px 16px',borderRadius:'6px',fontSize:'14px',color:'#2C3E50'},
  legalLinks:{display:'flex',justifyContent:'center',gap:'8px',marginTop:'40px',padding:'16px',background:'#F8F9FA',borderRadius:'8px'},
  llink:{color:'#3498DB',textDecoration:'none',fontSize:'13px',fontWeight:'600'},
  sep:{color:'#CCC'},
  copy:{textAlign:'center',color:'#999',fontSize:'12px',marginTop:'12px'},
};
